module.exports = __webpack_public_path__ + "static/media/mode-512.d01b3520.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-512.svg
// module id = 1042
// module chunks = 2